import { render, staticRenderFns } from "./StockViewTransportOrder.vue?vue&type=template&id=cc55b480&scoped=true"
import script from "./StockViewTransportOrder.vue?vue&type=script&lang=js"
export * from "./StockViewTransportOrder.vue?vue&type=script&lang=js"
import style0 from "./StockViewTransportOrder.vue?vue&type=style&index=0&id=cc55b480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc55b480",
  null
  
)

export default component.exports